module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/logo-3ca0597cfa9f6d6d3f4aed5cedbd676d.png";